/**
 * Claude (Anthropic) Adapter — INTERFACE ONLY. No SDK, no network, no key.
 *
 * Integration mirrors the OpenAI adapter: install @anthropic-ai/sdk,
 * provide an API key, implement generate() mapping the shared prompt shape
 * onto Anthropic's Messages API (`tools` + `tool_choice`), and register the
 * instance. Anthropic tool-use responses arrive as `tool_use` content
 * blocks — return them as { type: 'function_call', name, arguments }.
 */

import { AIProvider, NotImplementedError } from '../providerInterface';

export class ClaudeAdapter extends AIProvider {
  constructor({ apiKey = null, model = 'claude-sonnet-4-5' } = {}) {
    super({
      id: 'claude',
      name: 'Claude (not connected)',
      capabilities: { functionCalling: true, streaming: true, offline: false },
    });
    this.apiKey = apiKey;
    this.model = model;
  }

  isReady() {
    return false;
  }

  async generate() {
    throw new NotImplementedError(
      'Claude is not connected yet. Install @anthropic-ai/sdk, provide an API key, and implement ClaudeAdapter.generate() — see README.md.'
    );
  }
}
